import React from 'react'
import { useGlobal } from './GlobalContext'
import { empty, isEmptyObject } from '../utils/helpers/helpers'
import { getAssinaturaPorModalidade } from '../api/modalidade.servico'
import { getPlanoPorModalidade } from '../api/planos.servico'
import { getAssinaturaDoAssociadoPorModalidade, getInformacoesModalidadePorAssinatura } from '../utils/helpers/helpersAssinatura'
import { PLANO_SEMESTRAL } from '../constants'
import { getVideosRetencao } from '../api/cancelamento.servico'
import { httpStatus } from '../utils/request/httpStatus'
import { getValorPlano } from '../utils/helpers/helperPlano'

const ModalidadeContext = React.createContext()

function ModalidadeProvider( props ) {
  const [ state, setState ] = React.useState( {
    'assinaturaPorModalidade': null,
    'listaPlanosPorModalidade': null,
    'modal': null,
    'videosRetencao': null,
  } )

  const value = React.useMemo(
    () => {
      return {
        setState,
        state
      }
    },
    [ state ]
  )

  return (
    <ModalidadeContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useModalidade() {
  const context = React.useContext( ModalidadeContext )
  if ( !context ) {
    throw new Error( 'useModalidade deve ser usado dentro de um Provider' )
  }

  const { state, setState } = context
  const { dadosGlobaisAssociado, setErroRequisicao } = useGlobal()

  const setModal = modal => {
    setState( prevState => ( {
      ...prevState,
      modal
    } ) )
  }

  const setAssinaturaPorModalidade = assinaturaPorModalidade => {
    setState( prevState => ( {
      ...prevState,
      assinaturaPorModalidade
    } ) )
  }

  const setVideosRetencao = videosRetencao => {
    setState( prevState => ( {
      ...prevState,
      videosRetencao
    } ) )
  }

  const setPlanos = listaPlanosPorModalidade => {
    let listaPlanos = {}

    if ( listaPlanosPorModalidade.length ) {
      const planosPresente = listaPlanosPorModalidade.filter( plano => plano.isPresente && !plano.isFidelidade )
      const planosNaoPresente = listaPlanosPorModalidade.filter( plano => !plano.isPresente && !plano.isFidelidade && plano.tipo !== PLANO_SEMESTRAL.visualizacao )
      const planosFidelidade = listaPlanosPorModalidade.filter( plano => plano.isFidelidade )
      const planoSemestral = listaPlanosPorModalidade.filter( plano => !plano.isPresente && plano.tipo === PLANO_SEMESTRAL.visualizacao && !plano.isFidelidade )

      listaPlanos = {
        ...listaPlanos,
        planoSemestral,
        planosFidelidade,
        planosNaoPresente,
        planosPresente
      }
    }

    setState( ( prevState ) => ( {
      ...prevState,
      'listaPlanosPorModalidade': listaPlanos
    } ) )
  }

  const fetchPlanos = async modalidade => {
    const idModalidade = getInformacoesModalidadePorAssinatura( modalidade ).id
    try {
      const response = await getPlanoPorModalidade( idModalidade )
      if ( !isEmptyObject( response.data ) ) {
        const listaPlanos = response.data.planos.map( plano => {
          const assinatura = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidade )
          const valorPlano = getValorPlano( assinatura, plano.valorTotal, modalidade, plano.tipo )
          return {
            ...plano,
            'valorTotal': valorPlano
          }
        } )

        setPlanos( listaPlanos )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const filterValorPlano = ( assinaturaPorModalidade ) => {
    const valor = getValorPlano(
      assinaturaPorModalidade,
      assinaturaPorModalidade.valor
    )
    return { ...assinaturaPorModalidade, valor }
  }

  const fetchAssinaturaPorModalidade = async modalidade => {
    if ( !isEmptyObject( state.assinaturaPorModalidade ) ) {
      setAssinaturaPorModalidade( null )
    }

    const idModalidade = getInformacoesModalidadePorAssinatura( modalidade ).id

    try {
      const response = await getAssinaturaPorModalidade( idModalidade )
      if ( !empty( response.data ) ) {
        const assinaturaPorModalidade = filterValorPlano( response.data )
        setAssinaturaPorModalidade( assinaturaPorModalidade )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const pegarVideosRetencao = async() => {
    try {
      const response = await getVideosRetencao()
      if ( !isEmptyObject( response.data[ 0 ].dados ) && response.status === httpStatus.OK ) {
        setVideosRetencao( response.data[ 0 ].dados )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  return {
    'assinaturaPorModalidade': state.assinaturaPorModalidade,
    'enderecoVigente': state.enderecoVigente,
    fetchAssinaturaPorModalidade,
    fetchPlanos,
    'listaPlanosPorModalidade': state.listaPlanosPorModalidade,
    'modal': state.modal,
    pegarVideosRetencao,
    setAssinaturaPorModalidade,
    setModal,
    'videosRetencao': state.videosRetencao,
  }
}

export { ModalidadeProvider, useModalidade }
